import React, { useState, useEffect } from 'react';
import {CookieModalStyled} from "./styles";
import { CookieAcceptBtn} from "../buttons/buttons";
import {LinkStyled} from "../text/text";

const CookieModal = ({lang}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const cookieAccepted = localStorage.getItem('cookieAccepted');
        if (!cookieAccepted) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieAccepted', 'true');
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <>
            {lang === 'ru' ? (
                <CookieModalStyled>
                    <p> Данный сайт использует файлы данных о посещениях в соответствии с
                        <LinkStyled href="https://roscongress.content.rcmedia.ru/upload/iblock/8d5/nnql3rgh6an3ynxgperp3tosr7j4pxgl/Politika_obrabotki_PDn.pdf" target='_blank'> Политикой обработки персональных данных</LinkStyled> в Фонде «Росконгресс» и <LinkStyled href="https://roscongress.content.rcmedia.ru/upload/iblock/773/kg487b73e3i9my81xrf59l3n2fgc6qf8/Pravila_obrabotki_dannykh_dlya_vedeniya_statistiki.pdf" target='_blank'>Правилами обработки данных</LinkStyled> для ведения статистики. Продолжая пользоваться сайтом, Вы соглашаетесь на сбор и использование нами таких данных.</p>
                    <CookieAcceptBtn onClick={handleAccept}>Принимаю</CookieAcceptBtn>
                </CookieModalStyled>
            ) : (
                <CookieModalStyled>
                    <p> This website uses cookies in accordance with
                        <LinkStyled href="https://roscongress.content.rcmedia.ru/upload/iblock/086/mm8soe374jl9eif5ef441uhl67qemchz/Politika_obrabotki_PDn_En.pdf" target='_blank'> the Roscongress Foundation's Personal Data Processing Policy</LinkStyled> and <LinkStyled href="https://roscongress.content.rcmedia.ru/upload/iblock/ef5/gs2jgtetxvzubzypyigms39xku09ewlw/Rules_for_processing_data_for_maintaining_statistics.pdf" target='_blank'>Statistical Data Processing Rules</LinkStyled>. By continuing to use the site, you consent to our collection and use of cookies.</p>
                    <CookieAcceptBtn onClick={handleAccept}>Accept</CookieAcceptBtn>
                </CookieModalStyled>
            )}

        </>
    );
};

export default CookieModal;